import React, { useEffect } from 'react';
import { getScrollbarWidth } from '../../../helpers/index.es.js';
import { styled } from '../../../libs/styled.es.js';
import { Overlay } from '../../molecules/Overlay/Overlay.es.js';

const Backdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1000;
`;
const sizeMaps = {
  sm: "400px",
  md: "700px",
  lg: "960px"
};
const ModalContent = styled.div(({ theme, size, maxHeight, borderRadius }) => `
  background-color: ${theme.colors.white};
  display: flex;
  flex-direction: column;
  width: ${sizeMaps[size]};
  border-radius: ${borderRadius ? borderRadius : theme.borderRadius};
  max-height: ${maxHeight ? maxHeight : `90%`};
  z-index: 1060;
  position: relative;
  overflow-y: auto;
`);
const Modal = ({
  show,
  onHide,
  children,
  className,
  size = "md",
  maxHeight,
  borderRadius
}) => {
  useEffect(() => {
    if (typeof document !== "undefined") {
      if (show) {
        document.body.style.overflow = "hidden";
        document.body.style.paddingRight = `${getScrollbarWidth()}px`;
      }
    }
    return () => {
      document.body.style.overflow = "unset";
      document.body.style.paddingRight = "unset";
    };
  }, [show]);
  if (!show)
    return null;
  return /* @__PURE__ */ React.createElement(Overlay, {
    show,
    onEscPressed: onHide
  }, /* @__PURE__ */ React.createElement(Backdrop, {
    onClick: onHide
  }), /* @__PURE__ */ React.createElement(ModalContent, {
    className,
    size,
    borderRadius,
    maxHeight
  }, children));
};

export { Modal };
